import { createReducer } from "reduxsauce";
import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/homework/HomeworkHistoryActionTypes";
import HomeworkHistoryService from "../../../services/screens/homework/HomeworkHistoryService";
import AsyncActionReducers from "../../AsyncActionReducers";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (userHomeworkId, type) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, userHomeworkId });

            HomeworkHistoryService.loadScreenView(
                { userHomeworkId, type },
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error,
    }),

    setPageIndex: pageIndex => ({
        type: ActionTypes.SET_PAGEINDEX,
        pageIndex,
    }),

    replyUnitAsync: userHomeworkUnitId => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.REPLY_UNIT_ASYNC });

            HomeworkHistoryService.replyUnit(
                userHomeworkUnitId,
                response => {
                    const units = Array.from(getState().screens[reducer.key].units);
                    const unit = units.find(u => u.userHomeworkUnitId === userHomeworkUnitId);
                    dispatch(Actions.replyUnitSuccess(response, unit));
                },
                error => {
                    dispatch(Actions.replyUnitFailure(error));
                }
            );
        };
    },

    replyUnitSuccess: (data, unit) => ({
        type: ActionTypes.REPLY_UNIT_SUCCESS,
        parentType: ActionTypes.REPLY_UNIT_ASYNC,
        postReducer: replyUnitSuccessPostReducer,
        data,
        unit,
    }),

    replyUnitFailure: error => ({
        type: ActionTypes.REPLY_UNIT_FAILURE,
        parentType: ActionTypes.REPLY_UNIT_ASYNC,
        error,
    }),

    updateSettings: settings => ({
        type: ActionTypes.UPDATE_SETTINGS,
        settings
    }),

    playCommentAudio: val => ({
        type: ActionTypes.PLAY_COMMENT_AUDIO,
        val
    }),

    toggleTopicVisibility: val => ({
        type: ActionTypes.TOGGLE_TOPIC_VISIBILITY,
        val
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    units: null,
    pageIndex: 0,
    totalCount: null,
    settings: {
        pinyinVisible: true,
        translationVisible: true,
        answerVisible: false,
    },
    audioPaused: true,
    topicVisibility: false,
    title: "",
    userName: "",
    replied:new Set(),
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    let { units, title, userName } = data.userHomeworkDetails;
    return { ...state, units, totalCount: units.length, title, userName };
};

const replyUnitSuccessPostReducer = (state, { unit }) => {
    let replied = new Set(state.replied);
    replied.add(unit.userHomeworkUnitId)
    return { ...state, replied };
}

const setPageIndexReducer = (state, { pageIndex }) => {
    return { ...state, pageIndex, settings: { ...state.settings }, topicVisibility: false, audioPaused: true };
};

const updateSettingsReducer = (state, { settings }) => {
    return { ...state, settings };
};

const playCommentAudioReducer = (state, { val }) => {
    return { ...state, audioPaused: !val };
};

const toggleTopicVisibilityReducer = (state, { val }) => {
    return { ...state, topicVisibility: val, audioPaused: true };
};
// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SET_PAGEINDEX]: setPageIndexReducer,
    [ActionTypes.REPLY_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REPLY_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REPLY_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_SETTINGS]: updateSettingsReducer,
    [ActionTypes.PLAY_COMMENT_AUDIO]: playCommentAudioReducer,
    [ActionTypes.TOGGLE_TOPIC_VISIBILITY]: toggleTopicVisibilityReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.homework.homeworkhistory, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
